const lentaVideos = [
  {
    id: 1,
    src: "/assets/videos/lenta/1.mp4",
    poster: require("./images/lenta/video/1-1.jpg"),
  },
  {
    id: 2,
    src: "/assets/videos/lenta/2.mp4",
    poster: require("./images/lenta/video/2-2.jpg"),
  },
  {
    id: 3,
    src: "/assets/videos/lenta/3.mp4",
    poster: require("./images/lenta/video/3-3.jpg"),
  },
  {
    id: 4,
    src: "/assets/videos/lenta/4.mp4",
    poster: require("./images/lenta/video/4-4.jpg"),
  },
  {
    id: 5,
    src: "/assets/videos/lenta/5.mp4",
    poster: require("./images/lenta/video/5-2.jpg"),
  },
  {
    id: 6,
    src: "/assets/videos/lenta/6.mp4",
    poster: require("./images/lenta/video/6-2.jpg"),
  },
];

export default lentaVideos;
